import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=f0f4ee62&"
import script from "./Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports